import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@mui/material';

import APIS from "../../../utils/APIS"

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import { adminInputStyle } from "../../../components/ui/Admin/adminStyles.js"


const NewFormation = () => {
  const navigate = useNavigate()

  const { setOverlayForSave, setContents } = useContext(SuperAdminContext)

  const [hasChanged, setHasChanged] = useState(false)

  const [name, setName] = useState("");

  useEffect(() => {
    if (name !== "" && name?.length >= 3 ) {
      setHasChanged(true)
    } else {
      setHasChanged(false)
    }
  }, [name])

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setOverlayForSave(true)
    let values = {
      name: name,
      surname : '#TITRE',
      description : 'Description',
      feedbackTitle : '',
      feedbackFormID : "5",
      feedbackSeuil : 50,
      feedbackBtnType : 'primary',
      feedbackBtnText : 'Dashboard',
      feedbackSucces : 'Bravo\u00a0! Vous êtes sur le bon chemin, vous avez une bonne connaissance de votre connaissance\u00a0! Continuez à découvrir vos capacités\u00a0!',
      feedbackFail : 'Vous êtes sur le bon chemin, vous avez identifié les espaces où peuvent se loger de nouvelles connaissances\u00a0! A vous de les compléter au fur et à mesure de cette formation\u00a0!',
    }

    APIS.addContent(values).then((result) => {
      if (result?.id && result?.formations) {
        setContents(result?.formations)
        navigate('/admin/formation/player/'+result?.id)
        setOverlayForSave(false)
      } else {
        /* Fiche de Nawal du 06/10/2026 : une erreur du serveur etait avalee,
           et le voile d'enregistrement restait affiche sans fin. */
        setOverlayForSave(false)
        window.alert("Le module n'a pas pu être créé. Rechargez la page puis réessayez ; si cela recommence, prévenez Hicham.")
      }
    })


  }

  return (
    <>
      <Helmet>
        <title>Admin Modules | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            withBack="/admin/formation"
            title="Création d'un nouveau module"
          >
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              disabled={!hasChanged}
              onClick={() => {
                document.getElementById('hidden_form_submit').click()
              }}
            >
              Créer le module
            </Button>
          </TopBar>


          <form noValidate onSubmit={onSubmitForm}>
            <Box sx={{ padding:"0px 10px" }}>
              <Box>
                <Box>Nom du module</Box>
                <input
                  onChange={(e) => {setName(e.target.value)}}
                  value={name}
                  id="name"
                  name="name"
                  placeholder="FOCUS-SoftSkill"
                  type="text"
                  style={adminInputStyle}
                />
              </Box>
            </Box>
            <button hidden type="submit" id="hidden_form_submit">
              Action
            </button>
          </form>

        </Box>
      </Box>
    </>
  )
};

export default NewFormation;
